export const otherItemsDownloadOnMessage =
  "Please wait while the other download is not done";
